import React from 'react';

const ArtworkPreview = ({ 
    imageUrl,
    thumbnail,
    width, 
    height, 
    side = 'Front',
}) => {
    return (
        <a href={imageUrl} target='_blank' className="artworkPreview" rel="noreferrer">
            <div className="artworkImageContainer">
                <img src={thumbnail} alt={`${side} artwork`} thum className="artworkImage" />
                <div className="artworkDimensions">
                    {width} x {height}
                </div>
                <div className="artworkSideLabel">
                    {side}
                </div>
            </div>
        </a>
    );
};

export default ArtworkPreview;
